import React, { useState, useEffect } from "react";
import moment from "moment";

import "moment/locale/pt-br";
import "moment/locale/cs";
import "moment/locale/nl";
import "moment/locale/fr";
import "moment/locale/de";
import "moment/locale/it";
import "moment/locale/ja";
import "moment/locale/ko";
import "moment/locale/es";
import "moment/locale/pl";
import "moment/locale/ru";
import "moment/locale/zh-cn";
import "moment/locale/es";
import "moment/locale/zh-tw";
import "moment/locale/tr";

import wdl_logo from "./images/wdl-logo.png";
import steep_logo from "./images/steep-logo.png";
import acv_logo from "./images/acv-logo.png";
import acv_logo_ru from "./images/acv-logo_ru-RU.png";
import acv_logo_jp from "./images/acv-logo_ja-JP.png";
import acv_logo_zh_cn from "./images/acv-logo_zh-CN.png";
import acv_logo_zh_tw from "./images/acv-logo_zh-TW.png";
import steep2_logo from "./images/steep2_logo.png";
import sppd_logo from "./images/sppd-logo.png";
import tc2_logo from "./images/tc2-logo.png";
import fc6_logo from "./images/fc6-logo.png";
import fc6_logo_jp from "./images/fc6_logo_jp.png";
import fc6_logo_zh_cn from "./images/fc6_logo_SCH.png";
import fc6_logo_zh_tw from "./images/fc6_logo_TCH.png";
import r6e_logo from "./images/r6e-logo.png";
import r6e_logo_ru from "./images/r6e-logo-ru-RU.png"
import r6e_logo_jp from "./images/r6e_logo_ja-JP.png"
import r6e_logo_zh_cn from "./images/r6e_logo_zh-CN.png"
import r6e_logo_zh_tw from "./images/r6e_logo_zh-TW.png"
import rc_logo from "./images/rc_logo.png"
import pop_logo from "./images/pop_logo.png"
import pop_logo_zh_tw from "./images/pop_logo_zh-TW.png"
import pop_logo_jp from "./images/pop_logo_ja-JP.png"
import pop_logo_kr from "./images/pop_logo_ko-KR.png"
import skb_logo from "./images/skb_logo.png"
import xd_logo from "./images/xd_logo.png"
import fh_logo from "./images/fh-logo.png"
import r6s_logo from "./images/r6s_logo.png"
import r6sx_logo from "./images/r6x_logo.png"
import r6s_logo_tch from "./images/r6s_logo_tch.png"
import r6s_logo_jp from "./images/r6s_logo_jp.png"
import r6s_logo_ru from "./images/r6s_logo_ru.png"
import r6x_logo_tch from "./images/r6x-logo-tch.png"
import r6x_logo_jp from "./images/r6x-logo-jp.png"
import r6x_logo_kr from "./images/r6x-logo-kr.png"

import "./App.scss";

import { State, NewsItemDto, Ip2Location, GameStatusesDto, GameStatusesResponse, PlatformCode } from "./Types";
import statusPageData from './SpData';
import FooterComp from "./Footer";
import PlatformComp from "./Platform";
import localizationApi from "./Localizations";
import Locales from "./LocaleMapping";
import { useCookies } from "react-cookie";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FooterCompFh from "./Footer-fh";
import FooterCompR6e from "./Footer-r6s";

library.add(fas, far);
moment.locale('en-US');

declare var sp_identifier: string;
let data = statusPageData[sp_identifier];

const getLocaleByCountry = (countryCode?: string) => {
    var result = "en-US";
    return countryCode !== undefined ? Locales[countryCode.toUpperCase()] : result;
};

const fetchCountryByIp = async (localeCode: string | undefined, setCookie: (v: any) => void, update: (f: (s: State) => State) => void) => {
    if (localeCode !== undefined && localeCode !== "") return;

    var apiUrl = "https://public-ubiservices.ubi.com/v2/profiles/me/iplocation";
    const req = {
        credentials: "same-origin",
        headers: {
            Accept: "application/json",
            "Ubi-AppId": data.marketingSiteAppId
        },
    } as RequestInit;

    try {
        const response = await fetch(apiUrl, req);
        if (!response.ok) {
            update((s: State) => {
                return { ...s, locale: getLocaleByCountry("US") } as State;
            });
            return;
        }

        const data: Ip2Location = await response.json();
        update((s: State) => {
            if (localeCode !== undefined && localeCode !== "") return s;

            var countryCode = data.countryCode;
            var localeByCountry = getLocaleByCountry(countryCode);

            setCookie(localeByCountry);

            return { ...s, locale: localeByCountry } as State;
        });
    } catch {
        update((s: State) => {
            return { ...s, locale: getLocaleByCountry("US") } as State;
        });
    }
};

const tc2_rc_PlatformExceptions = (p: GameStatusesDto) => {
    switch (p.platformType) {
        case PlatformCode.PS4: return [p, { ...p, platformType: PlatformCode.PS5 }];
        case PlatformCode.XBOXONE: return [p, { ...p, platformType: PlatformCode.XBOXSX }];
        default: return [p];
    }
}

const withExceptions = (sp: string, data: GameStatusesDto[], locale: string) => {
    switch (sp) {
        case "tc2":
        case "rc":
            return data.flatMap(tc2_rc_PlatformExceptions);

        default: return data;
    }
}

const fetchStatus = async (sp: string, locale: string, update: (f: (s: State) => State) => void) => {
    var apiUrl = `https://public-ubiservices.ubi.com/v1/applications/gameStatuses?applicationIds=${data.appIds.join(',')}`;

    update((s: State) => {
        return { ...s, _loadingPlatforms: true } as State;
    });

    const req = {
        headers: {
            Accept: "application/json",
            "Ubi-AppId": data.marketingSiteAppId,
        },
    } as RequestInit;

    try {
        const response = await fetch(apiUrl, req);
        if (!response.ok) {
            update((s: State) => {
                return {
                    ...s,
                    platforms: [],
                    _loadingPlatforms: false,
                } as State;
            });
            return;
        }
        const responseBody: GameStatusesResponse = await response.json()
        const data = withExceptions(sp, responseBody.gameStatuses, locale);

        update((s: State) => {
            return {
                ...s,
                platforms: data,
                _loadingPlatforms: false,
            } as State;
        });
    } catch {
        update((s: State) => {
            return {
                ...s,
                platforms: [],
                _loadingPlatforms: false,
            } as State;
        });
    }
};

const rand = (n: number) => {
    return Math.floor(Math.random() * n + 1);
};

const fetchNews = async (locale: string, update: (f: (s: State) => State) => void) => {
    var n = rand(10000000);
    var apiUrl = `https://public-ubiservices.ubi.com/v1/spaces/news?spaceid=${data.marketingSiteSpaceId}&ver=` + n;

    const req = {
        credentials: "same-origin",
        headers: {
            Accept: "application/json",
            "Ubi-AppId": data.marketingSiteAppId,
            "Ubi-LocaleCode": locale,
        },
    } as RequestInit;

    update((s: State) => {
        return { ...s, _loadingNews: true } as State;
    });

    try {
        const response = await fetch(apiUrl, req);
        if (!response.ok) {
            update((s: State) => {
                return {
                    ...s,
                    news: [],
                    _loadingNews: false,
                } as State;
            });
            return;
        }

        const data: { news: NewsItemDto[] } = await response.json();
        update((s: State) => {
            return { ...s, news: data.news, _loadingNews: false } as State;
        });
    } catch {
        update((s: State) => {
            return {
                ...s,
                news: [],
                _loadingNews: false,
            } as State;
        });
    }
};

const getLogoImage = (sp_identifier: string, localeCode?: string) => {
    switch (sp_identifier) {
        case "steep": return steep_logo;
        case "wdl": return wdl_logo;
        case "acv":
            switch (localeCode) {
                case "ru-RU": return acv_logo_ru;
                case "ja-JP": return acv_logo_jp;
                case "zh-CN": return acv_logo_zh_cn;
                case "zh-TW": return acv_logo_zh_tw;
                default: return acv_logo;
            }
        case "steep2": return steep2_logo;
        case "sppd": return sppd_logo;
        case "tc2": return tc2_logo;
        case "fc6":
            switch (localeCode) {
                case "ja-JP": return fc6_logo_jp;
                case "zh-CN": return fc6_logo_zh_cn;
                case "zh-TW": return fc6_logo_zh_tw;
                default: return fc6_logo;
            }
        case "r6e":
            switch (localeCode) {
                case "ru-RU": return r6e_logo_ru;
                case "ja-JP": return r6e_logo_jp;
                case "zh-CN": return r6e_logo_zh_cn;
                case "zh-TW": return r6e_logo_zh_tw;
                default:
                    return r6e_logo;
            }
        case "rc":
            return rc_logo;
        case "pop":
            switch (localeCode) {
                case "ja-JP": return pop_logo_jp;
                case "ko-KR": return pop_logo_kr;
                case "zh-TW": return pop_logo_zh_tw;
                default: return pop_logo;
            }
        case "skb":
            return skb_logo;
        case "xd":
            return xd_logo;
        case "fh":
            return fh_logo;
        case "r6s":
            switch (localeCode) {
                case "ja-JP": return r6x_logo_jp;
                case "ko-KR": return r6x_logo_kr;
                case "zh-TW": return r6x_logo_tch;
                case "ru-RU": return r6s_logo_ru;
                default: return r6sx_logo;
            }
        default: return undefined;
    }
}

const support_VisitWebsite = (sp: string, locale: string) => {
    switch (sp) {
        case "fh": return (<p dangerouslySetInnerHTML={{ __html: localizationApi.GetVisitWebsitesLocaleFh(locale) }}></p>)
        case "tc2": return (<p>{localizationApi.GetVisitWebsitesLocaleTc2(locale)}</p>)
        default: return (<>
            <p>{localizationApi.GetVisitWebsitesLocale(locale)}</p>
            <ul className="list-unstyled">
                {data.helpLinks.map((link) =>
                    <li key={link.link}>
                        <a id="aCSupport" href={link.link} target="_blank" rel="noopener noreferrer">
                            {link.text}
                        </a>
                    </li>
                )}
            </ul>
        </>
        )
    }
}

function App() {
    const [timeLeft, setTimeLeft] = useState(60);
    const [cookies, setCookie, _removeCookie] = useCookies(["localeCode"]);
    const localeCode: string | undefined = cookies["localeCode"];

    const [state, setState] = useState<State>({
        platforms: [],
        news: [],
        loadDate: new Date(),
        locale: localeCode === undefined || localeCode === "" ? "en-US" : localeCode,

        _loadingPlatforms: false,
        _loadingNews: false,
    });

    moment.locale(localeCode);

    useEffect(() => {
        fetchCountryByIp(localeCode, (v) => setCookie("localeCode", v), setState);
        if (localeCode) moment.locale(localeCode === "zh-CN" || localeCode === "zh-TW" || localeCode === "pt-BR" ? localeCode : localeCode.substr(0, 2));
    }, [localeCode, setCookie]);

    useEffect(() => {
        fetchStatus(sp_identifier, state.locale, setState);
    }, [state.locale]);

    useEffect(() => {
        fetchNews(state.locale, setState);
    }, [state.locale]);

    useEffect(() => {
        setTimeout(() => {
            timeLeft <= 0
                ? (() => {
                    setTimeLeft(60);
                    setState(s => {
                        return { ...s, loadDate: new Date() };
                    });
                    fetchStatus(sp_identifier, state.locale, setState);
                    fetchNews(state.locale, setState);
                })()
                : setTimeLeft(Math.max(0, timeLeft - 1));
        }, 1000);
    });

    const serviceStatusText = localizationApi.GetServiceStatusLocale(state.locale);
    const liveStatusText = localizationApi.GetLiveStatusLocale(state.locale).replace("XYZ", timeLeft.toString());
    const needHelpText = localizationApi.GetNeedHelpLocale(state.locale);

    const globalNews = state.news.filter(n => !n.obj.platform);

    const collapse = state.platforms.filter(p => p._expanded).length === state.platforms.length;
    return (
        <>
            <nav className={"navbar navbar-dark bg-dark " + sp_identifier}>
                <div className="container">
                    <a href="/" className="navbar-brand">
                        <img className={"logo " + sp_identifier} src={getLogoImage(sp_identifier, state.locale)} alt={data.name}></img>
                    </a>
                    <small className="invisible">{sp_identifier}</small>
                </div>
            </nav>
            <div className="bg-dark">
                <header className={sp_identifier}>
                    <h1>{serviceStatusText}</h1>
                    <p>
                        {localizationApi.GetUpdatedLocale(state.locale)}&nbsp;<span>{moment(state.loadDate).format("LLL")}</span>{" "}
                        <button className="btn btn-link py-0" onClick={() => document.location.reload()} style={{ fontSize: "0.8em" }}>
                            {localizationApi.GetRefreshLocale(state.locale)}
                        </button>
                    </p>
                    <p className="auto-refresh">{liveStatusText}</p>
                </header>
            </div>

            <main className="container my-2 py-4 flex-grow-1">
                <div className="row">
                    <div className="col-12 col-sm-12 col-md-8">
                        <div className="bg-white px-4 py-2">
                            <div className="d-flex flex-column global-status flex-fill bg-white">
                                <div className="d-flex flex-row justify-content-between mt-2">
                                    <h2 className="mt-2 mb-4">{localizationApi.GetGlobalStatusLocale(state.locale)}</h2>
                                    {!state._loadingPlatforms ? (
                                        <button
                                            className="btn btn-link text-right pt-2"
                                            onClick={() =>
                                                setState(s => {
                                                    return {
                                                        ...s,
                                                        platforms: s.platforms.map(platform => {
                                                            return { ...platform, _expanded: collapse ? false : true };
                                                        }),
                                                    };
                                                })
                                            }>
                                            {collapse
                                                ? localizationApi.GetCollapsePlatformsLocale(state.locale)
                                                : localizationApi.GetExpandPlatformsLocale(state.locale)}

                                        </button>
                                    ) : null}
                                </div>

                                {/* platforms */}
                                {state._loadingPlatforms || state._loadingNews ? (
                                    <FontAwesomeIcon icon={["fas", "spinner"]} size="3x" className="d-block m-4" spin />
                                ) : (
                                    <>
                                        {state.platforms.map(i => (
                                            <PlatformComp
                                                key={i.platformType}
                                                platform={i}
                                                locale={state.locale}
                                                onToggle={platform => {
                                                    setState(s => {
                                                        return { ...s, platforms: s.platforms.map(existing => (existing.platformType === platform.platformType ? { ...platform, _expanded: !existing._expanded } : existing)) };
                                                    });
                                                }}
                                                sp_identifier={sp_identifier}
                                                news={state.news.filter(n => n.obj.platform?.toLowerCase() === i.platformType.toLowerCase())}
                                            />
                                        ))}
                                    </>
                                )}

                                {/* news */}
                                <div className="my-2">
                                    {globalNews.length === 0 ? null :
                                        state._loadingNews ? (
                                            <>
                                                <h2 className="my-1 pt-1 pb-0">{serviceStatusText}</h2>
                                                <FontAwesomeIcon icon={["fas", "spinner"]} size="3x" className="d-block m-4" spin />
                                            </>
                                        ) : (
                                            <>
                                                <h2 className="my-1 pt-1 pb-0">{serviceStatusText}</h2>
                                                <ul className="list-group mb-2 news-items">
                                                    {globalNews
                                                        .filter(newsItem => ["statuspage outage", "statuspage maintenance", "statuspage underinvestigation"].reduce<boolean>((prev, current, _idx, _arr) => prev || newsItem.placement.toLowerCase() === current, false))
                                                        .map(newsItem => {
                                                            const publicationDate = new Date(newsItem.publicationDate);
                                                            return (
                                                                <li key={newsItem.newsId} className="list-group-item d-flex flex-row justify-content-between news-item py-1 px-0">
                                                                    <div className="d-flex flex-column justify-content-between news-item px-0 w-100">
                                                                        <p className="text-muted mb-0">
                                                                            <small>{moment(publicationDate).format("MMM, DD")}</small>
                                                                        </p>
                                                                        <h3 className={"py-1 my-0"}>{newsItem.title}</h3>
                                                                        <p className="py-2 mb-0">{newsItem.body}</p>
                                                                    </div>
                                                                </li>
                                                            );
                                                        })}
                                                </ul>
                                            </>
                                        )}
                                </div>
                            </div>
                        </div>

                        <div className="support p-4">
                            <h2 className="my-2">{needHelpText}</h2>
                            {support_VisitWebsite(sp_identifier, state.locale)}
                        </div>
                    </div>
                    <aside className="col-12 col-sm-12 col-md-4">
                        <div className="bg-white px-4 py-4">
                            <h4>Tweets</h4>
                            <div id="dvTwitter" className="twitter-feeds">
                                <a className="twitter-timeline" href={"https://twitter.com/" + (data.twitter[state.locale] ?? data.twitter["default"])} data-chrome="noheader" data-height="600">Tweets by {(data.twitter[state.locale] ?? data.twitter["default"])}</a>
                            </div>
                        </div>
                    </aside>
                </div>
            </main>
            {!['fh', 'r6s'].includes(sp_identifier) &&
                <FooterComp
                    locale={state.locale}
                    sp_identifier={sp_identifier}
                    onLocaleChange={locale => {
                        setCookie("localeCode", locale);
                        document.location.reload(); // twitter widget needs to reload
                    }}
                />}
            {sp_identifier === 'fh' &&
                <FooterCompFh
                    locale={state.locale}
                    onLocaleChange={locale => {
                        setCookie("localeCode", locale);
                        document.location.reload(); // twitter widget needs to reload
                    }}
                />}
            {sp_identifier === 'r6s' &&
                <FooterCompR6e
                    locale={state.locale}
                    onLocaleChange={locale => {
                        setCookie("localeCode", locale);
                        document.location.reload(); // twitter widget needs to reload
                    }}
                />}

        </>
    );
}

export default App;
